import { NamedLink } from '../../../components';
import { FormattedMessage } from '../../../util/reactIntl';
import css from './SectionHero.module.css';
import classNames from 'classnames';
import { string } from 'prop-types';
import React from 'react';

const SectionHero = (props) => {
    const { rootClassName, className } = props;

    const classes = classNames(rootClassName || css.root, className);

    return (
        <div className={classes}>
            <div className={css.heroContent}>
                <h1 className={css.heroMainTitle}>
                    <FormattedMessage id="SectionHero.title" />
                </h1>
                <h2 className={css.heroSubTitle}>
                    <FormattedMessage id="SectionHero.subTitle" />
                </h2>
                <NamedLink name="SearchPage" className={css.heroButton}>
                    <FormattedMessage id="SectionHero.browseButton" />
                </NamedLink>
            </div>
        </div>
    );
};

SectionHero.defaultProps = { rootClassName: null, className: null };

SectionHero.propTypes = {
    rootClassName: string,
    className: string,
};

export default SectionHero;
